export const checkIfUserAdmin = (user) => {
  const isAdmin =
    user &&
    ((user?.ACL?.permissionsById &&
      Object.keys(user.ACL.permissionsById).includes("role:ROLE_ADMIN")) ||
      (user.ACL && Object.keys(user.ACL).includes("role:ROLE_ADMIN")));

  return isAdmin;
};

export const processDataForChart = (
  products,
  receipts,
  store,
  titleOfTooltip,
  dateRange
) => {
  let dateFrom = null;
  let dateTo = null;
  if (dateRange) {
    dateFrom = convertDateFormat(dateRange[0].startDate);
    dateTo = dateRange[0].endDate && convertDateFormat(dateRange[0].endDate);
  }
  const soldItems = [];
  let eligibleReceipts = receipts.filter((f) => f.attributes.pib === store.pib);
  eligibleReceipts = filterByDateRange(eligibleReceipts, dateFrom, dateTo);

  // Iterate through each receipt in the receipts array
  for (let i = 0; i < eligibleReceipts.length; i++) {
    const receipt = eligibleReceipts[i];

    const soldItemsForStore = {};

    // Iterate through each prize item in the receipt's prize_items array
    for (let j = 0; j < receipt.attributes.prize_items.length; j++) {
      const prizeItem = receipt.attributes.prize_items[j];

      // Find the product that matches the prize item's id
      const product = products.find(
        (product) => product.objectId === prizeItem.id
      );

      // Check if a sold item with this product ID already exists for this store
      if (product && soldItemsForStore[product.objectId]) {
        // If it does, add the quantity to the existing sold item
        soldItemsForStore[product.objectId].qty += parseInt(prizeItem.qty);
        soldItemsForStore[product.objectId].total =
          soldItemsForStore[product.objectId].qty * product.price;
      } else if (product) {
        // If it doesn't, create a new sold item for this store and product
        soldItemsForStore[product.objectId] = {
          receiptId: receipt.id,
          createdAt: receipt.attributes.createdAt,
          pib: receipt.attributes.pib,
          storeName: store.name,
          productId: product.objectId,
          productName: product.name,
          qty: parseInt(prizeItem.qty),
        };
      }
    }
    // Add all sold items for this store to the final array of sold items
    Object.values(soldItemsForStore).forEach((soldItem) => {
      soldItems.push(soldItem);
    });
  }
  const combinedSoldItems = soldItems.reduce((acc, cur) => {
    const existingSoldItem = acc.find(
      (item) => item.productId === cur.productId
    );
    if (existingSoldItem) {
      existingSoldItem.qty += cur.qty;
    } else {
      acc.push(cur);
    }
    return acc;
  }, []);

  const colors = [
    "rgb(255, 99, 132)",
    "rgb(54, 162, 235)",
    "rgb(255, 205, 86)",
    "rgb(143, 13, 229)",
    "rgb(198, 40, 40)",
    "rgb(0, 255, 0)",
    "rgb(0,0,128)",
    "rgb(128,128,0)",
    "rgb(30, 16, 1)",
    "rgb(128,0,128)",
    "rgb(0,128,128)",
    "rgb(32, 34, 45)",
    "rgb(103, 185, 229)",
    "rgb(78, 117, 0)",
  ];
  // console.log("combinedSoldItems",combinedSoldItems)
  const labels = combinedSoldItems.map((item) => item.productName);
  const qtys = combinedSoldItems.map((item) => item.qty);
  const itemColors = combinedSoldItems.map((item, index) => colors[index]);
  const data = {
    labels: labels,
    datasets: [
      {
        label: titleOfTooltip,
        data: qtys,
        backgroundColor: itemColors,
        hoverOffset: 4,
      },
    ],
  };

  return data;
};
export const convertDateFormat = (inputDate) => {
  if (inputDate) {
    const date = new Date(inputDate);
    const timezoneOffsetMs = date.getTimezoneOffset() * 60 * 1000;
    const utcTimestampMs = date.getTime() - timezoneOffsetMs;
    const utcDate = new Date(utcTimestampMs);
    const year = utcDate.getUTCFullYear();
    const month = `0${utcDate.getUTCMonth() + 1}`.slice(-2);
    const day = `0${utcDate.getUTCDate()}`.slice(-2);
    const hours = `0${utcDate.getUTCHours()}`.slice(-2);
    const minutes = `0${utcDate.getUTCMinutes()}`.slice(-2);
    const seconds = `0${utcDate.getUTCSeconds()}`.slice(-2);
    const milliseconds = `00${utcDate.getUTCMilliseconds()}`.slice(-3);
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }
  return null;
};
export const filterByDateRange = (items, dateFromStr, dateToStr) => {
  const dateFrom = new Date(dateFromStr);
  const dateTo = new Date(dateToStr);
  dateFrom.setHours(0, 0, 0, 0);
  dateTo.setHours(23, 59, 59, 999);

  return items.filter((item) => {
    const createdAt = new Date(item.attributes.createdAt);
    createdAt.setHours(0, 0, 0, 0);
    return createdAt >= dateFrom && createdAt <= dateTo;
  });
};
export const convertDate = (isoDateString) => {
  const dateObj = new Date(isoDateString);
  const humanReadableDateString = dateObj.toLocaleDateString("sr-Latn", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

  return humanReadableDateString;
};

export const extractSoldItems = (receipts, products) => {
  const soldItems = [];

  receipts?.forEach((receipt) => {
    const prizeItems = receipt.attributes.prize_items;

    prizeItems?.forEach((item) => {
      const itemId = item.id;
      const itemQty = parseInt(item.qty);

      const soldProduct = products?.find(
        (product) => product.objectId === itemId
      );

      if (soldProduct) {
        const productName = soldProduct.name;
        const existingItemIndex = soldItems.findIndex(
          (item) => item.itemName === productName
        );
        if (existingItemIndex >= 0) {
          soldItems[existingItemIndex].qty += itemQty;
        } else {
          soldItems.push({ itemName: productName, qty: itemQty });
        }
      }
    });
  });
  soldItems.sort((a, b) => b.qty - a.qty);

  return soldItems;
};
